// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2I_um","boxTitle":"Qualiphy_boxTitle__2Qwwu","box":"Qualiphy_box__3cCx3","toggleWrap":"Qualiphy_toggleWrap__2tvXs"};